
export const OPEN_PAYMENT_POPUP = 'OPEN_PAYMENT_POPUP';
export const CLOSE_PAYMENT_POPUP = 'CLOSE_PAYMENT_POPUP';
export const MONEY_GIVEN_CLEAR = 'MONEY_GIVEN_CLEAR';
export const MONEY_GIVEN_ADD = 'MONEY_GIVEN_ADD';
export const MONEY_GIVEN_CONNECT_TO_END = 'MONEY_GIVEN_CONNECT_TO_END';
export const PAYMENT_CHANGE_RADIO = 'PAYMENT_CHANGE_RADIO';
export const DISCOUNT_CHANGE_RADIO = 'DISCOUNT_CHANGE_RADIO';
export const RESET_PAYMENT_MONEY = 'RESET_PAYMENT_MONEY';
export const CLEAR_DISCOUNT = 'CLEAR_DISCOUNT';
export const SET_DEFAULT_PAYMENT_RADIO = 'SET_DEFAULT_PAYMENT_RADIO';
export const SET_PAYMENT_ITEMS_WITH_ZERO_DISCOUNT = 'SET_PAYMENT_ITEMS_WITH_ZERO_DISCOUNT';

export function setPaymentItemsWithZeroDiscount(items, price) {
    return {
        type: SET_PAYMENT_ITEMS_WITH_ZERO_DISCOUNT,
        payload: {items, price}
    }
}

export function clearDiscount() {
    return {
        type: CLEAR_DISCOUNT
    }
}

export function setDefaultPaymentRadio(type) {
    return {
        type: SET_DEFAULT_PAYMENT_RADIO,
        payload: type
    }
}

export function resetPaymentMoney(price) {
    return {
        type: RESET_PAYMENT_MONEY,
        payload: price
    }
}

export function discountChangeRadio(type) {
    return {
        type: DISCOUNT_CHANGE_RADIO,
        payload: {type}
    }
}

export function paymentChangeRadio(type, itemId) {
    return {
        type: PAYMENT_CHANGE_RADIO,
        payload: {type, itemId}
    }
}

export function openPaymentPopup() {
    return {
        type: OPEN_PAYMENT_POPUP
    }
}

export function closePaymentPopup() {
    return {
        type: CLOSE_PAYMENT_POPUP
    }
}

export function moneyGivenClear() {
    return {
        type: MONEY_GIVEN_CLEAR
    }
}

export function moneyGivenAdd(sum) {
    return {
        type: MONEY_GIVEN_ADD,
        payload: sum
    }
}

export function moneyGivenConnetToEnd(sum) {
    return {
        type: MONEY_GIVEN_CONNECT_TO_END,
        payload: sum
    }
}



// WEBPACK FOOTER //
// ./src/common/paymentPopup/actions.js